import { Injectable } from '@angular/core';

@Injectable()
export class LoggerFactory {
  constructor() {}
  public get(className: string): Logger {
    return new Logger(className);
  }
}

export class Logger {
  private static isProductionMode;
  private readonly className: string;

  public static setProductionMode(): void {
    Logger.isProductionMode = true;
  }

  constructor(className: string) {
    if (!className || className === '') {
      if (!Logger.isProductionMode) {
        throw Error('Class name is empty or null');
      }
    }
    this.className = className;
  }

  public warn(message: string) {
    if (!Logger.isProductionMode) {
      console.warn('%c[WARNING]', 'background:yellow;', `- ${this.className} –`, message);
    }
  }
  public error(message: string) {
    if (!Logger.isProductionMode) {
      console.error('%c[ERROR]', 'background:red;color:#fff;', `- ${this.className} –`, message);
    }
  }
  public info(message: any, ...optionalParams: any[]) {
    if (!Logger.isProductionMode) {
      console.log('%c[INFO]', 'background:blue;color:#fff;', `${this.className} –`, message, ...optionalParams);
    }
  }
  public debug(message: any, ...optionalParams: any[]) {
    if (!Logger.isProductionMode) {
      console.debug('%c[DEBUG]', 'background:dimgray;color:#fff;', `${this.className} –`, message, ...optionalParams);
    }
  }
}
